const answerNode = (answer) => {
  return {
    createdBy: answer?.createdBy ?? localStorage.getItem("ge_sso"),
    createdDate: answer?.createdDate ?? new Date().getTime(),
    lastUpdatedBy: localStorage.getItem("ge_sso") ?? answer?.lastUpdatedBy,
    lastUpdatedDate: new Date().getTime() ?? answer?.lastUpdatedDate,
  };
};

export const textAnswer = (newValue, answers) => {
  let node = answerNode(answers && answers[0]);
  node.answerValue = newValue;
  return [node];
};

export const dateAnswer = (newValue, answer) => {
  if (answer && answer[0] !== undefined) {
    answer[0].answerValue = newValue;
    answer[0].lastUpdatedBy =
      localStorage.getItem("ge_sso") ?? answer?.lastUpdatedBy;
    answer[0].lastUpdatedDate = new Date().getTime() ?? answer?.lastUpdatedDate;
    return answer;
  } else {
    let node = answerNode();
    node.answerValue = newValue;
    return [node];
  }
};

export const hoursAnswer = (newValue, answer) => {
  if (answer && answer[0] !== undefined) {
    answer[0].answerDescription = newValue;
    answer[0].lastUpdatedDate = new Date().getTime();
    return answer;
  } else {
    let node = answerNode();
    node.answerDescription = newValue;
    return [node];
  }
};

export const radioButtonAnswer = (value, comment, image) => {
  let node = answerNode();
  node.answerValue = value;
  // Checking for comment and image is required, because both keys may or may not have value.
  // 'answer' : [ { image: […], comment: 'sample comment', ... } ]
  if (comment !== "") {
    node.comment = comment;
  }
  if (image.length > 0) {
    node.image = image;
  }
  return [node];
};

export const checkBoxAnswer = (values, answers) => {
  let ans = [];
  values.forEach((value) => {
    const answer = answers?.find((answer) => answer?.answerValue === value);
    let node = answerNode(answer);
    node.answerValue = value;
    ans.push(node);
  });
  return ans;
};

export const dropDownAnswer = (values, comment, image) => {
  let answers = [];
  values.forEach((value) => {
    let node = answerNode();
    node.answerValue = value;
    // Checking for comment and image is required, because both keys may or may not have value.
    // 'answer' : [ { image: […], comment: 'sample comment', ... } ]
    if (comment !== "") {
      node.comment = comment;
    }
    if (image.length > 0) {
      node.image = image;
    }
    answers.push(node);
  });
  return answers;
};

export const rangeAnswer = (value, answers) => {
  let node = answerNode(answers && answers[0]);
  node.answerValue = value;
  return [node];
};

export const addAnswer = (answer, elementId, form) => {
  if (answer && elementId && form && form.children) {
    form.children.forEach((child) => {
      child.children.forEach((sectionChild) => {
        if (sectionChild.children && sectionChild.children.length > 0) {
          sectionChild.children.forEach((subSectionChild) => {
            if (subSectionChild.id === elementId) {
              subSectionChild.answer = answer;
            }
          });
        } else {
          if (sectionChild.id === elementId) {
            sectionChild.answer = answer;
          }
        }
      });
    });
  }
  return form;
};

export const updateAnswer = (formAnswers, answers, id) => {
  formAnswers?.children?.forEach((child) => {
    if (child?.elementId === id) {
      const nextAnswers = Array.isArray(answers) ? answers : [];
      // Replace existing answers to prevent stale values from deselected options.
      if (!Array.isArray(child.answer)) {
        child.answer = [];
      }
      child.answer.length = 0;
      nextAnswers.forEach((ans) => {
        child.answer.push(ans);
      });
    }
  });
  return formAnswers;
};
